export default {
    data() {
        return {
            /**
             * 通用tableList Mixins
             * 查询列表数据方法名称 @function  queryTaleData 
             */
            searchForm: {},
            page: {
                currentPage: 1,
                total: 0,
                layout: "total,pager,prev, next",
                background: false,
                pageSize: 10,
                pageSizes:[10, 15, 20, 30, 50, 100]
            }            
        }
    },
    methods: {

        // 分页 修改页码大小
        handleSizeChange(value){
            this.page.pageSize = value
            this.queryTableData()
        },
       // 分页 当前页变动  
        handleCurrentChange(value) {
            this.page.currentPage = value
            this.queryTableData()
        },
        searchBtn() {
            this.page.currentPage = 1
            this.queryTableData()
        },
        // dictionaryLabel(key,dataList)  {
        //     if(!validateNull(key)){
        //         let filterList=dataList.filter(item=>{
        //          return item.value==key
        //         })
        //         if(filterList.length>0){
        //            return filterList.map(item=>item.label).join(",")
        //         }else {
        //             return '/'
        //         }
                
        
        //     }else{
        //        return '/'
        //     }
            
        // }   
    }
}